import { TextareaAutosize, styled } from "@mui/material";

function Textarea({ textAlign, onChange, ...props }) {
  return (
    <TextareaAutosizeStyled
      onChange={onChange}
      textAlign={textAlign}
      {...props}
    />
  );
}

const TextareaAutosizeStyled = styled(TextareaAutosize)(
  ({ textAlign, theme }) => ({
    background: theme.palette.modules.input,
    width: "100%",
    outline: "none",
    border: "none",
    color: theme.palette.text.main,
    borderRadius: "8px",
    padding: "16.5px 14px",
    fontSize: "1rem",
    textAlign: textAlign || "left",
    "&::placeholder": {
      fontSize: "14px",
      color: theme.palette.text.secondary,
    },
    "&:focus": {
      border: `1px solid ${theme.palette.info.lightest}`,
    },
  })
);

export default Textarea;
